(() => {
  if (customElements.get('sn-display-currency')) return;
  const ARAB = {BH:'BHD',SA:'SAR',AE:'AED',KW:'KWD',QA:'QAR',OM:'OMR',EG:'EGP',JO:'JOD',IQ:'IQD',LB:'LBP',PS:'ILS',SY:'SYP',YE:'YER',DZ:'DZD',MA:'MAD',TN:'TND',LY:'LYD',SD:'SDG',MR:'MRU',SO:'SOS',DJ:'DJF',KM:'KMF'};
  const EUROPE = new Set('AL AD AM AT AZ BY BE BA BG HR CY CZ DK EE FO FI FR GE DE GI GR GG VA HU IS IE IM IT JE XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE CH TR UA GB KZ AX'.split(' '));
  const PRICE_SELECTOR = '.sn-variant-summary strong,[data-sticky-price],.price-item,.money,.totals__total-value,.cart-item__price-wrapper,.cart-item__discounted-prices,.cart-item__totals .price,.sn-upsell-info b,.snps-price,.snps-difference,.sncu-price,.sncu-difference,.sncp-price,.sn-delivery-line,.sn-delivery-track,.discounts__discount,.unit-price,.price-per-item,.quantity-popover__info';
  const SKIP_SELECTOR = 'script,style,select,textarea,input,svg,[contenteditable="true"],sn-display-currency,.snfx-checkout-note';
  const STORAGE = 'snfx-display-v1';
  const RATE_STORAGE = 'snfx-rates-bhd-v1';
  const GEO_STORAGE = 'snfx-country-v1';
  const MAX_RATE_AGE = 72 * 60 * 60;
  const currencyFor = country => ARAB[country] || (EUROPE.has(country) ? 'USD' : 'BHD');
  const read = (storage, key) => { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const numberValue = value => {
    let text = value.replace(/[٠-٩]/g, c => String(c.charCodeAt(0) - 1632)).replace(/[۰-۹]/g, c => String(c.charCodeAt(0) - 1776)).replace(/٬/g, ',').replace(/٫/g, '.').replace(/[\s\u200e\u200f\u061c]/g, '');
    if (text.includes('.') && text.includes(',')) text = text.lastIndexOf('.') > text.lastIndexOf(',') ? text.replace(/,/g, '') : text.replace(/\./g, '').replace(',', '.');
    else if (text.includes(',')) text = /,\d{3}(?:,|$)/.test(text) ? text.replace(/,/g, '') : text.replace(',', '.');
    return Number(text);
  };
  class DisplayCurrency extends HTMLElement {
    connectedCallback() {
      if (this.started || this.dataset.base !== 'BHD') return;
      this.started = true;
      this.text = JSON.parse(this.querySelector('[data-snfx-text]').textContent);
      this.locale = this.dataset.locale || 'en';
      this.select = this.querySelector('[data-snfx-select]');
      this.notice = this.querySelector('[data-snfx-notice]');
      this.credit = this.querySelector('[data-snfx-credit]');
      this.code = this.querySelector('[data-snfx-code]');
      this.menu = this.querySelector('details');
      this.onOutside = event => { if (!this.contains(event.target)) this.menu.open = false; };
      document.addEventListener('click', this.onOutside);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.menu.open = false; this.querySelector('summary').focus(); } });
      this.records = new WeakMap();
      this.rate = 1;
      this.currency = 'BHD';
      this.country = '';
      this.sequence = 0;
      this.choice = 'auto';
      const regionNames = new Intl.DisplayNames([this.locale], {type:'region'});
      const currencyNames = new Intl.DisplayNames([this.locale], {type:'currency'});
      Object.entries(ARAB).forEach(([country, currency]) => {
        const option = document.createElement('option');
        option.value = currency;
        option.textContent = `${regionNames.of(country)} — ${currency}`;
        this.select.append(option);
      });
      const dollar = document.createElement('option');
      dollar.value = 'USD';
      dollar.textContent = `${this.text.europe} — USD`;
      this.select.append(dollar);
      this.currencyNames = currencyNames;
      if (![...this.select.options].some(option => option.value === this.choice)) this.choice = 'auto';
      this.select.value = this.choice;
      this.select.addEventListener('change', () => {
        this.choice = this.select.value;
        write(localStorage, STORAGE, this.choice);
        this.activate(this.choice === 'auto' ? currencyFor(this.country) : this.choice);
      });
      this.observer = new MutationObserver(mutations => {
        if (mutations.some(mutation => !this.contains(mutation.target) && !mutation.target.parentElement?.closest('.snfx-checkout-note'))) this.schedule();
      });
      this.observe();
      this.hidden = false;
      this.detect().then(country => {
        this.country = country;
        this.select.options[0].textContent = `${this.text.auto} (${currencyFor(country)})`;
        if (this.choice === 'auto') this.activate(currencyFor(country));
      });
      if (this.choice !== 'auto') this.activate(this.choice);
    }
    disconnectedCallback() { this.observer?.disconnect(); document.removeEventListener('click', this.onOutside); }
    observe() { this.observer.observe(document.body, {childList:true, subtree:true, characterData:true}); }
    async detect() {
      const cached = read(sessionStorage, GEO_STORAGE);
      if (cached && Date.now() - cached.time < 30 * 60 * 1000 && /^[A-Z]{2}$/.test(cached.country)) return cached.country;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country%5Benabled%5D=true`, {credentials:'same-origin', signal:AbortSignal.timeout(6000)});
        if (!response.ok) throw Error('geo');
        const value = await response.json();
        const country = value.detected_values?.country?.handle;
        if (!/^[A-Z]{2}$/.test(country || '')) throw Error('geo');
        write(sessionStorage, GEO_STORAGE, {country, time:Date.now()});
        return country;
      } catch (_) { return 'BH'; }
    }
    validRates(value) {
      const age = Date.now() / 1000 - value?.time_last_update_unix;
      return value?.result === 'success' && value.base_code === 'BHD' && age >= -3600 && age < MAX_RATE_AGE && value.rates?.BHD === 1;
    }
    async rates() {
      const cached = read(localStorage, RATE_STORAGE);
      if (this.validRates(cached) && Date.now() / 1000 < cached.time_next_update_unix) return cached;
      if (!this.rateRequest) this.rateRequest = (async () => {
        try {
          const response = await fetch('https://open.er-api.com/v6/latest/BHD', {credentials:'omit', signal:AbortSignal.timeout(6000)});
          if (!response.ok) throw Error('rates');
          const value = await response.json();
          if (!this.validRates(value)) throw Error('rates');
          write(localStorage, RATE_STORAGE, value);
          return value;
        } catch (_) { return this.validRates(cached) ? cached : null; }
        finally { this.rateRequest = null; }
      })();
      return this.rateRequest;
    }
    async activate(currency) {
      const sequence = ++this.sequence;
      let rate = 1;
      if (currency !== 'BHD') {
        const value = await this.rates();
        if (sequence !== this.sequence) return;
        rate = value?.rates?.[currency];
        if (!(Number.isFinite(rate) && rate > 0)) {
          this.currency = 'BHD';
          this.rate = 1;
          this.notice.textContent = this.text.unavailable;
          this.credit.hidden = true;
          this.flush();
          return;
        }
      }
      this.currency = currency;
      this.rate = rate;
      this.formatter = new Intl.NumberFormat(`${this.locale}-u-nu-latn`, {style:'currency', currency, currencyDisplay:'code'});
      this.notice.textContent = currency === 'BHD' ? this.text.checkout : `${this.text.estimate} · ${this.text.checkout}`;
      this.credit.hidden = currency === 'BHD';
      this.flush();
      document.dispatchEvent(new CustomEvent('sn:display-currency', {detail:{currency, checkoutCurrency:'BHD'}}));
    }
    format(value) { return this.formatter.format(value * this.rate); }
    convert(text) {
      if (this.currency === 'BHD') return text;
      const digits = '[0-9٠-٩۰-۹]';
      const amount = `${digits}(?:[0-9٠-٩۰-۹.,٬٫]*${digits})?`;
      const marker = '(?:BHD|BD|د\\s*\\.\\s*ب\\.?)';
      const pattern = new RegExp(`${marker}\\s*(${amount})|(${amount})\\s*${marker}`, 'gi');
      return text.replace(pattern, (match, before, after) => {
        const value = numberValue(before || after);
        return Number.isFinite(value) ? this.format(value) : match;
      });
    }
    schedule() {
      if (this.pending) return;
      this.pending = requestAnimationFrame(() => { this.pending = null; this.flush(); });
    }
    flush() {
      this.observer.disconnect();
      const seen = new Set();
      document.querySelectorAll(PRICE_SELECTOR).forEach(element => {
        if (element.closest(SKIP_SELECTOR)) return;
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (seen.has(node) || node.parentElement.closest(SKIP_SELECTOR)) continue;
          seen.add(node);
          const saved = this.records.get(node);
          const original = saved && node.data === saved.output ? saved.original : node.data;
          const output = this.convert(original);
          if (node.data !== output) node.data = output;
          this.records.set(node, {original, output});
        }
      });
      document.querySelectorAll('.cart__ctas').forEach(anchor => {
        let note = anchor.previousElementSibling;
        if (!note?.classList.contains('snfx-checkout-note')) {
          note = document.createElement('p');
          note.className = 'snfx-checkout-note';
          anchor.before(note);
        }
        note.hidden = this.currency === 'BHD';
        note.textContent = `${this.text.estimate} · ${this.text.checkout}`;
      });
      this.dataset.currency = this.currency;
      this.code.textContent = this.currency;
      this.observe();
    }
  }
  customElements.define('sn-display-currency', DisplayCurrency);
})();

